import React from "react";
import { Helmet } from "react-helmet-async";

const CANONICAL_ORIGIN = (process.env.REACT_APP_SITE_URL || "https://abonelikiptal.com").replace(/\/+$/, "");
const BRAND_LOGO_URL = `${CANONICAL_ORIGIN}/branding/abonelik-iptal/logo512.png`;

/**
 * SEO helmet for a single route.
 * Props:
 *  - title            (required) full <title>
 *  - description      (required) meta description
 *  - path             (required) canonical path, e.g. "/vodafone-net-iptal"
 *  - image            optional absolute image URL
 *  - noindex          optional boolean — emits robots noindex,nofollow
 *  - jsonLd           optional array of JSON-LD objects
 */
export default function SEO({
  title,
  description,
  path = "/",
  image,
  noindex = false,
  jsonLd,
}) {
  const url = `${CANONICAL_ORIGIN}${path}`;
  const img = image || null;
  const lds = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      {!noindex && <meta name="robots" content="index,follow" />}

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      {img && <meta property="og:image" content={img} />}
      <meta property="og:site_name" content="Abonelik İptal" />
      <meta property="og:locale" content="tr_TR" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {img && <meta name="twitter:image" content={img} />}

      {/* JSON-LD */}
      {lds.map((ld, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(ld)}
        </script>
      ))}
    </Helmet>
  );
}

export { BRAND_LOGO_URL, CANONICAL_ORIGIN };
